<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'auditoria',
                })
            "
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Auditoria de Matrículas
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field
          v-model="search"
          class="my-2"
          append-icon="mdi-magnify"
          label="Pesquisar..."
          solo
          autofocus
          dense
          clearable
          single-line
          hide-details
        />
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="matriculasList"
          :items-per-page="15"
          :hide-default-footer="true"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="matricula.estaDeletado ? ['deleted'] : []"
                v-for="matricula of items"
                :key="matricula.id"
              >
                <td>{{ matricula.id }}</td>
                <td>{{ matricula.nome_escola }}</td>
                <td>{{ matricula.nome_turma }}</td>
                <td>{{ matricula.nome_aluno }}</td>
                <td>
                  <e-situacao-matricula :situacao="matricula.situacao" />
                </td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => verHistorico(matricula)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Ver Histórico de Alterações</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="listarMatriculas"
          :search="search"
        ></e-paginate>
      </v-col>
    </v-row>

    <e-drawer-ver-auditoria
      v-model="exibir"
      :auditated_model="matricula ?? {}"
      :auditated_descripition="$route.name"
    >
    </e-drawer-ver-auditoria>
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import Matricula from "@/Models/Matricula";

export default {
  data() {
    return {
      matricula: null,
      exibir: false,
      dataTableFilter,
      search: null,
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      disciplinas: [],
      disciplina: "",
      bimestres: [],
      bimestre: "",
      turmas: [],
      turma: "",
      professor: "",
      matriculasList: [],
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Escola" },
          { text: "Turma" },
          { text: "Aluno" },
          { text: "Situação" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  watch: {
    matriculas(value) {
      if (value && this.matriculasList.length === 0) {
        this.$loaderService.open("Carregando matrículas");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val?.length > 1) {
        await this.listarMatriculas(0, val);
      }
      if (!val) {
        await this.listarMatriculas(0);
      }
    },
  },
  async mounted() {
    this.matriculas = true;
    this.$loaderService.open("Carregando matrículas");
    await this.loadData();
    this.carregandoMatriculas = false;
    this.$loaderService.close();
  },
  methods: {
    async loadData() {
      await this.listarMatriculas(this.pageNumber);
    },
    async listarMatriculas(pageNumber, query = null) {
      this.matriculas = true;
      try {
        const response = await this.$services.matriculasService.auditoriaPaginate(
          pageNumber,
          query
        );
        this.matriculasList = response.data.map((matricula) => new Matricula(matricula));
        this.paginate = response;
      } catch (error) {
        this.$handleError(error);
      }
      this.matriculas = false;
    },
    verHistorico(matricula) {
      this.exibir = !this.exibir;
      this.matricula = matricula;
    },
  },
};
</script>

<style></style>
